"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSchemaProperties = exports.NotificationSchema = exports.NotificationResourceSchema = exports.NotificationActorSchema = exports.NotificationPreviewSchema = exports.NotificationStatusEnum = exports.NotificationTypeEnum = void 0;
const zod_1 = require("zod");
const activity_log_schema_1 = require("./activity-log-schema");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.NotificationTypeEnum = zod_1.z.enum(["system", "activity", "action"]);
exports.NotificationStatusEnum = zod_1.z.enum([
    "read",
    "unread",
    "scheduled",
    "archived",
]);
exports.NotificationPreviewSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    imageUrl: zod_1.z.string().optional(),
    linkUrl: zod_1.z.string().optional(),
    createdAt: zod_1.z.date().optional(),
    updatedAt: zod_1.z.date().optional(),
});
exports.NotificationActorSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: activity_log_schema_1.ActorTypeEnum,
    preview: exports.NotificationPreviewSchema,
});
exports.NotificationResourceSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: activity_log_schema_1.ResourceTypeEnum,
    preview: exports.NotificationPreviewSchema,
});
exports.NotificationSchema = base_schema_1.BaseSchema.extend({
    subject: zod_1.z.string().nullable(),
    body: zod_1.z.string().nullable(),
    type: exports.NotificationTypeEnum,
    status: exports.NotificationStatusEnum,
    remindOn: zod_1.z.date().optional(),
    actor: exports.NotificationActorSchema.optional(),
    action: activity_log_schema_1.ActivityActionEnum.optional(),
    resource: exports.NotificationResourceSchema.optional(),
});
exports.NotificationSchemaProperties = {
    collectionName: "notifications",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=notification-schema.js.map